export class AlpacaLiability {
    id: string = '';
    quote_id: string = '';
    acerage: number = null;
    is_public_interaction_allowed: number = null;       
    public_liability_cover: number = null;       
}
